import {RouterModule, Routes} from '@angular/router';
import {UserListComponent} from './components/user-list/user-list.component';
import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {TranslateModule} from '@ngx-translate/core';
import {SharedModule} from '@shared/shared.module';
import {UserManagementContainerComponent} from './container/user-management-container.component';
import {CreateUserPopupComponent} from './components/popups/create-user-popup/create-user-popup.component';
import {DisplayConsentModule} from '../display-consent/display-consent.module';
import {StoreModule} from '@ngrx/store';
import {UserManagementReducer} from './store';
import {A11yModule} from '@angular/cdk/a11y';
import {MatIconModule} from '@angular/material/icon';
import {PermissionsPopupComponent} from './components/popups/permissions-popup/permissions-popup.component';
import {EffectsModule} from '@ngrx/effects';
import {UserManagementEffects} from './store/user-management-effects';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {UserItemComponent} from './components/user-item/user-item.component';
import {MoreInfoPopupComponent} from './components/popups/more-info-popup/more-info-popup.component';
import {MatMenuModule} from '@angular/material/menu';
import {EditRolesPopupComponent} from './components/popups/edit-roles-popup/edit-roles-popup.component';
import {MatTooltipModule} from '@angular/material/tooltip';
import {MatFormFieldModule} from '@angular/material/form-field';
import {MatInputModule} from '@angular/material/input';
import {UserInfoComponent} from './components/popups/create-user-popup/user-info/user-info.component';
import {EducationInfoComponent} from './components/popups/choose-education-popup/education-info/education-info.component';
import {StepRolesComponent} from './components/popups/common/step-roles/step-roles.component';
import {ChooseEducationPopupComponent} from './components/popups/choose-education-popup/choose-education-popup.component';
import {InfiniteScrollModule} from 'ngx-infinite-scroll';
import {CoreModule} from '@core/core.module';

const routes: Routes = [
    {
        path: '',
        component: UserManagementContainerComponent
    }
];

@NgModule({
    declarations: [
        UserManagementContainerComponent,
        UserListComponent,
        UserItemComponent,
        CreateUserPopupComponent,
        EditRolesPopupComponent,
        StepRolesComponent,
        PermissionsPopupComponent,
        MoreInfoPopupComponent,
        UserInfoComponent,
        EducationInfoComponent,
        ChooseEducationPopupComponent
    ],
    exports: [
        UserListComponent
    ],
    imports: [
        RouterModule.forChild(routes),
        StoreModule.forFeature(UserManagementReducer.REDUCER_NAME, UserManagementReducer.reducer),
        EffectsModule.forFeature([UserManagementEffects]),
        CommonModule,
        TranslateModule,
        SharedModule,
        DisplayConsentModule,
        A11yModule,
        MatIconModule,
        FormsModule,
        MatMenuModule,
        ReactiveFormsModule,
        MatTooltipModule,
        MatFormFieldModule,
        MatInputModule,
        InfiniteScrollModule,
        CoreModule
    ]
})
export class UserManagementModule {
}
